import { Switch } from "@mantine/core";
import { useLsEnergyPriceUnit } from "../../hooks/useLsEnergyUnit";

function EnergyPriceUnitSwitch() {
  const { energyPriceUnit, setEnergyPriceUnit } = useLsEnergyPriceUnit();
  return (
    <Switch
      aria-label={energyPriceUnit}
      checked={energyPriceUnit === "ct/kWh"}
      offLabel={energyPriceUnit}
      size="lg"
      onChange={(event) =>
        setEnergyPriceUnit(event.currentTarget.checked ? "ct/kWh" : "€/MWh")
      }
      onLabel={energyPriceUnit}
    />
  );
}

export { EnergyPriceUnitSwitch };
